export enum LoadingAction {
  START = 'l0',
  FINISH = 'l1'
}

export const startLoading = () => ({ type: LoadingAction.START })
export const finishLoading = () => ({ type: LoadingAction.FINISH })
